<template>
  <!--
    Teleportado explicitamente para .glass-app (em vez de renderizar in-place)
    porque este componente é genérico e pode ser aberto a partir de sítios já
    dentro de outro Teleport (ex.: um VueFinalModal, que se teleporta para
    fora de #app/.glass-app). Sem isto, as variáveis CSS do tema
    (--fundoForm, --text, etc., definidas em .glass-app) não chegavam aqui.
  -->
  <Teleport to=".glass-app">
    <div class="historico-objeto-overlay" @click.self="$emit('close')">
      <div class="historico-objeto-content">
        <div class="historico-objeto-header">
          <h2 class="text-base font-bold text-[var(--titulo)]">
            <i class="fa-solid fa-clock-rotate-left mr-2"></i>
            Histórico — {{ tituloComputado }} #{{ objetoId }}
          </h2>
          <button
            class="text-[var(--glass-muted)] hover:text-[var(--text)] text-lg leading-none"
            title="Fechar"
            @click="$emit('close')"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="historico-objeto-body scrollbar-thin scrollbar-tema">
          <GenericDataTable
            :api-url="`${baseURl}/api/v1/historico/`"
            :columns="historicoColumns"
            :use-server-side="true"
            :initial-params="{ model_name: modelName, objeto_id: objetoId }"
            :default-order-column="0"
            :default-order-direction="'desc'"
            :show_export="true"
            :show_close_btn="false"
            :table_title="`Histórico ${tituloComputado} ${objetoId}`"
            :table_subtitle="`Todas as alterações registadas para ${tituloComputado} #${objetoId}`"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";

export default {
  name: "HistoricoObjetoModal",
  components: { GenericDataTable },
  props: {
    modelName: {
      type: String,
      required: true,
    },
    objetoId: {
      type: [Number, String],
      required: true,
    },
    // Nome amigável do modelo a mostrar no título (ex. "Negócio"). Se vazio,
    // usa o próprio modelName.
    titulo: {
      type: String,
      default: "",
    },
  },
  emits: ["close"],
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      historicoColumns: [
        {
          key: "data",
          label: "Data/Hora",
          type: "datetime",
          sortable: true,
          maxWidth: 150,
        },
        {
          key: "acao",
          label: "Ação",
          type: "badge",
          sortable: true,
          maxWidth: 100,
        },
        {
          key: "campo",
          label: "Campo Alterado",
          type: "text",
          sortable: true,
          computed: (row) => row.campo || "—",
        },
        {
          key: "valor_anterior",
          label: "Valor Anterior",
          type: "text",
          sortable: false,
          computed: (row) => (row.valor_anterior === null || row.valor_anterior === "" ? "—" : row.valor_anterior),
        },
        {
          key: "valor_novo",
          label: "Novo Valor",
          type: "text",
          sortable: false,
          computed: (row) => (row.valor_novo === null || row.valor_novo === "" ? "—" : row.valor_novo),
        },
        {
          key: "utilizador_nome",
          label: "Utilizador",
          type: "text",
          sortable: true,
          maxWidth: 160,
        },
      ],
    };
  },
  computed: {
    tituloComputado() {
      return this.titulo || this.modelName;
    },
  },
};
</script>

<style scoped>
.historico-objeto-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.historico-objeto-content {
  background: var(--fundoApp);
  color: var(--text);
  border-radius: 0.5rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  width: 100%;
  max-width: 1100px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.historico-objeto-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid var(--glass-border);
  background: var(--fundoForm);
  flex-shrink: 0;
}

.historico-objeto-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem;
}
</style>
